import React, { useEffect, useState } from "react";

const SVGFromURL = ({ url }) => {
  const [svgContent, setSvgContent] = useState("");

  useEffect(() => {
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        setSvgContent(text);
      })
      .catch((error) => console.error(error));
  }, [url]);

  return <div dangerouslySetInnerHTML={{ __html: svgContent }} />;
};

export default SVGFromURL;
